<template>
    <ul>
        <li v-for="item in navigation" :key="item.path" :class="itemClass(item)">
            <NuxtLink :to="item.path">{{ item.title }}</NuxtLink>
            <CmsNavigationList v-if="item.children" :navigation="item.children" :root />
        </li>
    </ul>
</template>
<script setup lang="ts">
const { navigation, root = "/" } = defineProps<{ navigation: CMSNavItem[]; root?: string }>();
const route = useRoute();

function itemClass(item: CMSNavItem) {
    return { active: item.path === root ? route.path === root : route.path.startsWith(item.path) };
}
</script>
